import { render, staticRenderFns } from "./coverSettingsDetails.vue?vue&type=template&id=175fac67&"
import script from "./coverSettingsDetails.vue?vue&type=script&lang=js&"
export * from "./coverSettingsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "coverSettingsDetails.vue"
export default component.exports